const safeWindow: Window & typeof globalThis =
  typeof window !== 'undefined'
    ? window
    : ({
        // 👇 Basic Mock of window object
        location: {
          href: '',
          pathname: '',
          search: '',
          hash: '',
          protocol: '',
          host: '',
          hostname: '',
          port: '',
          origin: '',
          assign: () => {},
          reload: () => {},
          replace: () => {},
          toString: () => '',
        },
        navigator: {
          userAgent: 'SSR',
          language: 'en',
          languages: [],
          platform: '',
          onLine: false,
        },
        document: {
          body: {},
          createElement: () => ({}),
          querySelector: () => null,
          getElementById: () => null,
          addEventListener: () => {},
          removeEventListener: () => {},
        },
        addEventListener: () => {},
        removeEventListener: () => {},
        setTimeout: () => 0,
        clearTimeout: () => {},
        setInterval: () => 0,
        clearInterval: () => {},
        embeddedservice_bootstrap: {
          init: () => {},
          settings: {},
          prechatAPI: {
            setHiddenPrechatFields: () => {},
            setVisiblePrechatFields: () => {},
          },
          utilAPI: {
            launchChat: () => {},
            sendTextMessage: () => {},
          },
        },
        // ? Se puede seguir añadiendo mocks necesarios
      } as unknown as Window & typeof globalThis);

export default safeWindow;
